module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    },
    on: {
      "closemodal": _vm.cancel,
      "close": _vm.cancel
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Calendar Settings")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(!_vm.getSlimFilters || _vm.getIsLoadingEvents) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pt-4 fs-large dark bold"
  }, [_vm._v("\n                Select the information you want to be visible in the events.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row pt-4 pb-2"
  }, [_c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getCurrentAccountType.isCalendarToShowStartEndTime),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isCalendarToShowStartEndTime", $$v)
      },
      expression: "getCurrentAccountType.isCalendarToShowStartEndTime"
    }
  }), _vm._v("\n                    Show Event Date (Start/End)\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getCurrentAccountType.isCalendarToShowProductName),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isCalendarToShowProductName", $$v)
      },
      expression: "getCurrentAccountType.isCalendarToShowProductName"
    }
  }), _vm._v("\n                    Show Product Name\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getCurrentAccountType.isCalendarToShowEventResourcesName),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isCalendarToShowEventResourcesName", $$v)
      },
      expression: "getCurrentAccountType.isCalendarToShowEventResourcesName"
    }
  }), _vm._v("\n                    Show Resource\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getCurrentAccountType.isCalendarToShowQuantityAvailable),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isCalendarToShowQuantityAvailable", $$v)
      },
      expression: "getCurrentAccountType.isCalendarToShowQuantityAvailable"
    }
  }), _vm._v("\n                    Show Availability\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getCurrentAccountType.isCalendarToShowOccupancy),
      callback: function($$v) {
        _vm.$set(_vm.getCurrentAccountType, "isCalendarToShowOccupancy", $$v)
      },
      expression: "getCurrentAccountType.isCalendarToShowOccupancy"
    }
  }), _vm._v("\n                    Show Occupancy\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('div', {
    staticClass: "w-100 mt-2"
  }, [_c('label', [_vm._v("Default Calendar View")]), _vm._v(" "), _c('vSelect', {
    attrs: {
      "options": _vm.calendarViewOptions,
      "reduce": function (name) { return name.value; },
      "label": "name"
    },
    on: {
      "input": function($event) {
        return _vm.changeDefaultCalendarView($event)
      }
    },
    model: {
      value: (_vm.defaultCalendarView),
      callback: function($$v) {
        _vm.defaultCalendarView = $$v
      },
      expression: "defaultCalendarView"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row pb-4"
  }, [_c('div', {
    staticClass: "col-sm-6 d-flex align-items-center py-2"
  }, [_c('div', {
    staticClass: "w-100 mt-2"
  }, [_c('label', [_vm._v("Show Sales Channels Availability Indicator")]), _vm._v(" "), _c('vSelect', {
    attrs: {
      "placeholder": "Select a Sale Channel",
      "label": "brandName",
      "options": _vm.salesChannel,
      "reduce": function (brandName) { return brandName.id; }
    },
    on: {
      "input": _vm.setSelectedSalesChannelToShowInIndicator
    },
    model: {
      value: (_vm.selectedSalesChannelToShowInIndicatorID),
      callback: function($$v) {
        _vm.selectedSalesChannelToShowInIndicatorID = $$v
      },
      expression: "selectedSalesChannelToShowInIndicatorID"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.getUpdatingSupplierSettings || _vm.getIsLoadingEvents
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-377bb02c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377bb02c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/calendarSettings.vue
// module id = 2169
// module chunks = 0